var exports = {
  "wx": "PremiumBadgeSettings.module__header___NEJwTU",
  "DD": "PremiumBadgeSettings.module__title___NEJwTU",
  "h_": "PremiumBadgeSettings.module__description___NEJwTU",
  "n$": "PremiumBadgeSettings.module__switches___NEJwTU",
};

module.exports = exports;
